<template>
  <div class="onboarding-step">
    <div class="onboarding-step__wrap">
      <a
        href="#"
        class="btn --large"
        id="pad-onboarding"
        pad-start
        pad-a="click"
        pad-up="go:#pad-platform"
        pad-down="go:#pad-onboarding-back"
        pad-right="go:#pad-onboarding-back"
        @click.prevent="$emit('nextStep')"
      >
        <span class="btn__stroke"></span>
        <span class="btn__label">{{ $t("get_started") }}</span>
      </a>
      <p v-if="game === 'bg3'" class="onboarding-step__description">
        {{ $t("onboarding_description") }}
      </p>
      <p v-else class="onboarding-step__description">
        {{ $t("onboarding_description_dos") }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    game: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-step {
  &__wrap {
    height: 100%;
  }

  &__description {
    font-family: "Gilam Bold", sans-serif;
    color: $white;
    text-align: center;
    position: absolute;
    bottom: calc(35% - 100px);
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 615px;
  }

  .btn {
    position: absolute;
    bottom: 35%;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
